import { Link, styled } from '@nextiva/next-ui-components';

export const LinkStyled = styled(Link)`
  color: ${({ theme }) => theme.palette.blue[800]};
  cursor: pointer;
  &:visited {
    color: ${({ theme }) => theme.palette.blue[800]};
    cursor: pointer;
  }
  &:hover {
    color: ${({ theme }) => theme.palette.blue[800]};
    cursor: pointer;
  }
`;
